'use client';

import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { Button } from 'stylus-ui/Button';

import { useCaptureError } from '@/_hooks/useCaptureError/useCaptureError';
import { SupportDropdown } from '@/viewer/[pid]/_components/AccessViews/SupportDropdown';

const Error = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
  const router = useRouter();
  const { captureError } = useCaptureError();

  useEffect(() => {
    captureError(error, {
      tags: {
        action: 'Error',
        location: 'app router error boundary'
      }
    });
  }, [error]);

  return (
    <main className='relative grid h-screen place-items-center'>
      <div className='flex h-full max-w-screen-sm flex-col justify-center p-8'>
        <div className='absolute left-0 top-0 flex w-full items-center justify-between p-6'>
          <Button icon={faArrowLeft} variant='secondary' onClick={() => router.back()} />
          <SupportDropdown />
        </div>
        <Image src='/logo-icon-brand-red.svg' alt='Scribe Logo' width={50} height={50} />
        <h2 className='m-0 p-0 text-2xl font-bold md:text-3xl'>Something went wrong</h2>
        <p className='text-balance font-normal md:text-lg'>Please reload the page and try again </p>
        <Button onClick={() => reset()}>Try again</Button>
      </div>
    </main>
  );
};

export default Error;
